import { withNamespaces } from "react-i18next"
import Accordion from 'react-bootstrap/Accordion';
import { Col, Row, Table } from "reactstrap";
import { RiContactsLine, RiFileList3Line } from "react-icons/ri";

const ContactInfo = ({
    t,
    activeAccordion,
    setActiveAccordion,

    detailsQuery
}) => {
    if (detailsQuery.isFetching) {
        return (
            <Row>
                <Col 
                    sm="12" 
                    className="mt-4 mb-4"
                >
                    <div 
                        className="dt-field dt-skeleton" 
                        style={{ width: '100%', height: '100px' }}
                    />
                </Col>
            </Row>
        )
    }

    const renderAddress = (address) => (
        <tr key={address.full_address}>
            <td>{address.full_address || "-"}</td>
            <td>{address.street || "-"}</td>
            <td>{address.city || "-"}</td>
            <td>{address.postal_code || "-"}</td>
            <td>{address.country || "-"}</td>
            <td>{address.telephone || "-"}</td>
        </tr>
    );

    const organizationData = JSON.parse(detailsQuery.data?.company?.organizationData || "");

    const contactInfo = organizationData?.contact_information || {};

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('contact-information')}
            className={activeAccordion === 'contact-information' ? 'active' : ''}
            eventKey={'contact-information'}
        >
            <Accordion.Header>
                <RiContactsLine size="24" className="me-2" />

                <span>
                    {t('Contact Information')}
                </span>
            </Accordion.Header>

            <Accordion.Body>
                <h5 className="fw-bold font-size-16">
                    {t('Main Address')}
                </h5>
                <Table striped bordered hover size="sm" className="mb-4">
                    <thead>
                        <tr>
                            <th>{t('Full Address')}</th>
                            <th>{t('Street')}</th>
                            <th>{t('City')}</th>
                            <th>{t('Postal Code')}</th>
                            <th>{t('Country')}</th>
                            <th>{t('Telephone')}</th>
                        </tr>
                    </thead>
                    <tbody>{renderAddress(contactInfo.main_address)}</tbody>
                </Table>

                {contactInfo.other_addresses?.length > 0 && (
                    <>
                        <h5 className="fw-bold font-size-16">{t('Other Addresses')}</h5>
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th>{t('Full Address')}</th>
                                    <th>{t('Street')}</th>
                                    <th>{t('City')}</th>
                                    <th>{t('Postal Code')}</th>
                                    <th>{t('Country')}</th>
                                    <th>{t('Telephone')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {contactInfo.other_addresses.map((addr) => renderAddress(addr))}
                            </tbody>
                        </Table>
                    </>
                )}
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default withNamespaces()(
    ContactInfo
)